// extracted by mini-css-extract-plugin
module.exports = {"MealItem":"MealItem_MealItem__JrAo7","Meal":"MealItem_Meal__3ZPvQ","MealItemPrice":"MealItem_MealItemPrice__1VHkb"};